module.exports = __webpack_public_path__ + "img/baokuan.5cb669ae.png";